import React, { useState, useContext } from "react";
import DomainContext from "Context/DomainContext";
import "./styles.scss";
import useScrollToTop from "Components/Hooks/useScrollToTop";
import { useEffectOnce } from "Components/Hooks/useEffectOnce";
import { APIQueryGet } from "APIMethods/API";
import { Link, useNavigate } from "react-router-dom";
import { SearchIcon, XIcon } from "Res/icons";
import IconButton from "@mui/material/IconButton";
import { SkeletonLine } from "Components/Skeletion";
import Seo from "Components/Seo/Seo";
import { ACTION_OPEN__LOGIN } from "Store/action";
import { useDispatch, useSelector } from "react-redux";
import AdvancedLink from "Components/AdvancedLink";

function SiteMap() {
  useScrollToTop();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { defaultURL, storeId } = useContext(DomainContext);
  const [data, setData] = useState();
  const [searchKeyword, setSearchKeyword] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const isLoggedUser = useSelector((state) => state?.isLoggedUser);

  const CategoryListItem = ({ category, searchKeyword }) => {
    return (
      <>
        <div key={category?.id} className="column overall-container">
          <p
            className={`${
              searchKeyword?.length > 3 && !category.names?.toLowerCase().includes(searchKeyword?.toLowerCase())
                ? "hide"
                : ""
            } ${category.names ? "main-category" : ""}`}
          >
            <AdvancedLink
              to={`/${category?.url_key}`}
              state={{
                currentPageView: category?.plp_design_view,
              }}
              onClick={() => {
                localStorage.setItem("fromPLPCategory_id", 0);
                localStorage.setItem("fromPLPCategory_url", "");
              }}
              style={{ display: category?.name || category?.names ? "block" : "none" }}
              aria-label={category?.names || category?.name}
            >
              {category?.names ? category?.names : category?.name}
            </AdvancedLink>
          </p>

          {category?.sub && category.sub.length > 0 && (
            <div className="pl-4 category-list">
              {category?.sub?.map((childCategory) => (
                <CategoryListItem key={childCategory?.id} category={childCategory} searchKeyword={searchKeyword} />
              ))}
            </div>
          )}
        </div>
      </>
    );
  };

  const renderCategories = (categories, searchKeyword) => {
    return categories?.map((category) => (
      <CategoryListItem
        key={category?.id}
        category={category}
        searchKeyword={searchKeyword} // Pass searchKeyword to renderCategories
      />
    ));
  };
  const options = {
    isLoader: true,
    setGetResponseData: (resData) => {
      setData(resData?.data[0]);
    },
    axiosData: {
      url: `${defaultURL}/getSitemap?storeId=${storeId}`,
    },
  };
  useEffectOnce(() => APIQueryGet(options));
  return (
    <React.Fragment>
      <Seo
        metaTitle={storeId === 1 ? "Sitemap | Promofit.nl" : "Sitemap | Expofit.nl"}
        metaDescription="Sitemap"
        metaKeywords="Sitemap"
      />
      <div className="sitemap__container container px-4 pt-5">
        <h1 className="fw-700 line-9 fs-30 py-4">{data?.title}</h1>
        <div className={`search px-4 pb-3 relative ${isFocused ? "focused" : ""}`}>
          <input
            type="text"
            className="searchbox pr-14 pl-6"
            aria-label="search"
            placeholder="Zoek op categorie of product"
            onFocus={() => {
              setIsFocused(true);
            }}
            onChange={(e) => {
              setSearchKeyword(e.target.value);
            }}
            value={searchKeyword}
          />
          <IconButton
            className="mr-2"
            aria-label="search toggle"
            onClick={() => {
              setSearchKeyword("");
            }}
          >
            {searchKeyword ? (
              <XIcon style={{ width: 14, height: 14 }} role="presentation" />
            ) : (
              <SearchIcon role="presentation" />
            )}
          </IconButton>
        </div>
        {data ? (
          <>
            <div className="category__list">
              <h2 className="fw-700 line-9 fs-30 py-4">{data?.categoriesTitle}</h2>
              <div className="category-container">{renderCategories(data?.categories?.root?.main, searchKeyword)}</div>
            </div>
            <div className="product__list">
              <h2 className="fw-700 line-9 fs-30 py-4">{data?.productsTitle}</h2>
              <ul className="pl-4">
                {Object.values(data?.products || {}).map((product, index) => (
                  <li key={index}>
                    <Link
                      to={`/${product.request_path}`}
                      onClick={() => {
                        localStorage.setItem("fromPLPCategory_id", 0);
                        localStorage.setItem("fromPLPCategory_url", "");
                      }}
                      aria-label={product?.name}
                      style={{ display: product?.name ? "block" : "none" }}
                      className={`${
                        searchKeyword?.length > 3 && !product.name.toLowerCase().includes(searchKeyword.toLowerCase())
                          ? "hide"
                          : ""
                      }`}
                    >
                      {product.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="product__list">
              <h2 className="fw-700 line-9 fs-30 py-4">{data?.linksTitle}</h2>
              <ul className="pl-4">
                {data?.links?.map((productName, index) => (
                  <li key={index}>
                    <Link
                      to={`/${productName?.url}`}
                      aria-label={productName?.title}
                      className={`${
                        searchKeyword?.length > 3 &&
                        !productName.title.toLowerCase().includes(searchKeyword.toLowerCase())
                          ? "hide"
                          : ""
                      }`}
                      onClick={(e) => {
                        if (!isLoggedUser && productName?.title?.includes("Inloggen")) {
                          e.preventDefault();
                          dispatch(ACTION_OPEN__LOGIN(true));
                        } else {
                          localStorage.setItem("fromPLPCategory_id", 0);
                          localStorage.setItem("fromPLPCategory_url", "");
                          navigate(productName?.url);
                        }
                      }}
                      style={{ display: productName?.title ? "block" : "none" }}
                    >
                      {productName?.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </>
        ) : (
          <div className="category__list">
            <ul className="category-container">
              {Array.from({ length: 29 }).map((_, index) => (
                <div className="py-4" key={index}>
                  <SkeletonLine width="100%" height="30px" />
                </div>
              ))}
            </ul>
          </div>
        )}
      </div>
    </React.Fragment>
  );
}

export default SiteMap;
